import React, {useState, useEffect} from 'react';
import surahList from '../data/surah.json';
import quranList from '../data/quran.json';
import tafseerList from '../data/tafseer.json';
import _ from 'lodash';

export default function Coran(){
    
const [surahID, setSurahID] = useState(null)
const [sourResults, setSourResults] = useState(surahList)
const [tafseerON, setTafseerON] = useState(false)

const getID = (id) => {
    setSurahID(id)
}

useEffect(() => {
    getID();
},[])


const searchSourahs = (e) => {
        if(e.target.value < 1) {
            setSourResults(surahList)
        } else {
    const re = new RegExp(_.escapeRegExp(e.target.value), 'i')
    const isMatch = (result) => re.test(result.name)
    let filtered = _.filter(surahList, isMatch)
    setSourResults(filtered)
        }
    }


// if the surah is selected, display the surah content, else display the surahs list.
if (surahID ==null) {
    return(
        
    <div>
        
            <div className="section">
            <div className="columns is-centered">
                <div className="column is-2 is-centered">
                    <div class="control">
                        <input class="input is-rounded" type="text" placeholder="بحث سريع" onChange={searchSourahs} />
                    </div>
                </div>
            </div>
                <div className="columns is-multiline">
                    {sourResults.map(item =>(
                    <div className="column is-2">
                        <div className="box is-warning is-large" style={{cursor: 'pointer'}} onClick={() => getID(item.number)
                        }>{item.name}</div>
                    </div> 
                    ))}
                </div>
            </div>

    </div>

    )
} else { //Display the Surah content
    
    // let's put the selected surah array in "s" FROM THE QURAN.JSON FILE
let s = quranList.filter(surah => surah.number === surahID);
// let's put the selected surah array in "p" FROM THE SURAH.JSON FILE
let p = surahList.filter(surah => surah.number === surahID);
// fetch Surah's Name
let surahName = s.map(item => item.name);
// fetch Surah's Type
let surahType = s.map(item => item.revelationType ==="Meccan" ? <h3>مكية</h3> : <h3>مدنية</h3>);
//fetch Surah's number of ayahs
let numberOfAyahs = p.map(item => item.numberOfAyahs);

const searchAyahs = (e) => {
}
const switchTafseer = () => {
    if(tafseerON === false){
        setTafseerON(true)
    }else setTafseerON(false)
}
const showTooltip = (aid) => {
    if(tafseerON === true){
        return tafseerList.filter(f => f.ayah === aid).map(n => n.text)
    }
}

    return (
    <div>
        <div className="section">
        <div className="columns is-centered">
                <div className="column is-2 is-centered">
                    <div class="control">
                        <input class="input is-rounded" type="text" placeholder="بحث سريع" onChange={searchAyahs} />
                    </div>
                </div>
            </div>
            <div className="columns is-centered">
                <div className="column is-2 has-text-right">
                    <div className="content">
                <button className="button is-warning is-active" onClick={() => {setSurahID(null); setSourResults(surahList);}}> عودة للخلف</button>
                    </div>
                    <article class="message is-warning is-medium">
                        <div class="message-body has-text-right">
                            <h1>{surahName}</h1>
                            <p>{surahType}</p>
                            <p>عدد آياتها: {numberOfAyahs}</p>
                            <div class="field">
                    <input id="switchRtlExample" type="checkbox" name="switchRtlExample" onChange={switchTafseer} class="switch is-rounded is-warning" checked={tafseerON} />
                    <label for="switchRtlExample">تفسير سريع</label>
                </div>
                        </div>
                        
                    </article>
                    </div>
                    <div className="column is-7">

                    <div className="box">
                        {surahID !== 9 ? <h1 className="basmalah">بِسْمِ ٱللَّهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ</h1> : ""}
                        <ul className="ul-ayahs">
                        {s.map( item => (
                        <li className="list-ayahs">{item.ayahs.map(t => <li className="has-tooltip-multiline" data-tooltip={showTooltip(t.number)}>{t.text}<span>﴿{t.numberInSurah}﴾</span></li>)}</li>
                        ))}
                        </ul>
                        <h1 className="tasdik">صدق ٱللَّهِ العظيم</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
        

}
}